import React from 'react'
import { View } from 'react-native'
import Svg, { Circle } from 'react-native-svg'

interface ProgressCircleProps {
  progress: number
  size?: number
  strokeWidth?: number
}

const ProgressCircle: React.FC<ProgressCircleProps> = ({ progress, size = 24, strokeWidth = 2 }) => {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const strokeDashoffset = circumference * (1 - progress)

  return (
    <View>
      <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <Circle cx={size / 2} cy={size / 2} r={radius} stroke="#DDDAD2" strokeWidth={strokeWidth} fill="none" />

        <Circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#4CAF50"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </Svg>
    </View>
  )
}

export default ProgressCircle
